import { CButton } from "@coreui/react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";

export const HistoryButton = ({className, ...props}) => {
    
    const {t} = useTranslation("Buttons");
    
    return (
        <CButton type="button" color="success" size="sm" className={classNames(className)} {...props}><FontAwesomeIcon icon={faHistory} className="mr-2"/>{t("history")}</CButton>
    );
};


export default HistoryButton;